import { FaFacebook } from "react-icons/fa6";
import { type SocialPlatformBaseSettings } from "./types";

export const facebookBaseSettings: SocialPlatformBaseSettings = {
  name: "Facebook",
  icon: FaFacebook,
  fields: {
    caption: "optional",
    location: "optional",
    altText: "optional",
    linkAttachment: "optional",
    polls: "optional",
    userTags: "optional",
  },
  limits: {
    caption: 63206,
    images: 10, // Applies to standard posts
    videos: 1,
    videoDurationSeconds: 240 * 60,
    pollOptions: 10, // Example limit
  },
  notes: ["Ideal caption length: 40-80 characters."],
  postTypes: {
    post: {
      notes: ["Video length max 240 mins (under 1 min recommended)."],
    },
    reel: {
      nameSuffix: " Reel",
      fields: {
        caption: "required",
        polls: "not_allowed",
        linkAttachment: "not_allowed",
      },
      limits: { images: 0, videoDurationSeconds: 90 }, // Reels are video-only, shorter duration
      notes: ["Reels focus on short-form video."],
    },
    story: {
      nameSuffix: " Story",
      fields: {
        caption: "optional",
        polls: "optional",
        linkAttachment: "optional",
      },
      limits: { images: 1, videos: 1, videoDurationSeconds: 60 }, // Typically shorter
      notes: ["Stories are ephemeral (24h)."],
    },
  },
};
